import React from 'react';
const modules = [{
  num: '1',
  title: 'Functional Training Foundations',
  description: 'The science behind every movement decision you make.'
}, {
  num: '2',
  title: 'The 250+ Exercise Library',
  description: 'Every exercise you need, with cues, progressions, and regressions.'
}, {
  num: '3',
  title: 'The Workout Builder System',
  description: 'Plug-and-play templates for 30, 45, and 60-minute sessions.'
}, {
  num: '4',
  title: '100 Ready-to-Use Workouts',
  description: 'The complete vault. Beginner, Intermediate, and Advanced.'
}, {
  num: '5',
  title: 'Client Transformation Programs',
  description: 'Structured 4, 8, and 12-week programs ready to deliver.'
}, {
  num: '6',
  title: 'Professional Coaching & Client Success System',
  description: 'Assessments, retention, and communication tools.'
}];
export function TomiSection() {
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <div className="text-center mb-5" data-id="element-186">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-2" data-id="element-187">
            THE SYSTEM YOU'VE BEEN WAITING FOR — A 6-IN-1 OPERATING SYSTEM
          </h2>
          <p className="text-base text-brand-graphite/70 mb-3" data-id="element-188">
            6 professional modules in 1, designed for serious coaching
            professionals
          </p>
          <div className="inline-block bg-brand-petrol/10 border-2 border-brand-petrol px-4 py-1.5 rounded-lg mb-3" data-id="element-189">
            <p className="font-bold text-brand-petrol text-lg" data-id="element-190">
              FUNCTIONAL PRO™ 6-in-1 Complete System
            </p>
          </div>
          <p className="text-base text-brand-graphite/80 max-w-3xl mx-auto" data-id="element-191">
            FUNCTIONAL PRO™ is much more than a simple manual. It is a complete
            operating system that delivers professional functional sessions,
            structured to guarantee flow, progression, and authority in every
            training environment.
          </p>
        </div>

        <div className="space-y-3" data-id="element-192">
          {modules.map((module, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-4 rounded-lg flex gap-3 items-start" data-id="element-193">
              <div className="bg-brand-petrol text-white font-bold px-4 py-2 rounded text-sm shrink-0" data-id="element-194">
                MODULE {module.num}
              </div>
              <div data-id="element-195">
                <h3 className="text-lg font-bold text-brand-graphite mb-1" data-id="element-196">
                  {module.title}
                </h3>
                <p className="text-brand-graphite/70 text-sm" data-id="element-197">
                  {module.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}